// Défiler doucement verticalement

// eslint-disable-next-line import/prefer-default-export,import/no-mutable-exports,no-var
export var mixinHelpers = {
  methods: {
    // Défiler doucement verticalement
    // Source: https://stackoverflow.com/questions/49636727/why-is-scroll-behaviorsmooth-not-working-but-javascript-window-scroll-smooth-is
    mixinHelpers_smoothScrollTo(endX = 0, endY = 0, duration = 500) {
      const startX = window.scrollX;
      const startY = window.scrollY;
      const distanceX = endX - startX;
      const distanceY = endY - startY;
      const startTime = new Date().getTime();

      // Easing function
      const easeInOutQuart = function (time, from, distance, duration) {
        // eslint-disable-next-line no-cond-assign
        if ((time /= duration / 2) < 1) return (distance / 2) * time * time * time * time + from;
        // eslint-disable-next-line no-return-assign
        return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
      };

      const timer = window.setInterval(function () {
        const time = new Date().getTime() - startTime;
        const newX = easeInOutQuart(time, startX, distanceX, duration);
        const newY = easeInOutQuart(time, startY, distanceY, duration);
        if (time >= duration) {
          window.clearInterval(timer);
        }
        window.scrollTo(newX, newY);
      }, 1000 / 60); // 60 fps
    },
  },
};
